import { Card, CardContent, CardMedia, Typography, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import DeviceManager from '@/components/util/deviceManager';
import { navigationTranslationState } from '../../../../../store';

export const ActionTooltip = ({ detailedRouteEnabled, showSearchField, sharingPopupOpen, children, rtl }) => {
  const [open, setOpen] = useState(false);
  const translation = useRecoilValue(navigationTranslationState);

  useEffect(() => {
    let timeoutId;

    if (detailedRouteEnabled && !showSearchField && !sharingPopupOpen && !DeviceManager.isMobile()) {
      timeoutId = setTimeout(() => {
        setOpen(true);
      }, 3000);
    }

    return () => {
      clearTimeout(timeoutId);
      setOpen(false);
    };
  }, [detailedRouteEnabled, showSearchField, sharingPopupOpen]);

  return (
    <Tooltip
      open={open}
      arrow
      placement="right"
      componentsProps={{
        arrow: { sx: { color: '#fff' } },
        tooltip: {
          sx: {
            background: '#fff',
            p: '12px',
            borderRadius: '8px',
            gap: '10px',
            width: '185px',
          },
        },
      }}
      PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, 20] } }] }}
      title={
        <Card
          sx={{
            position: 'relative',
            background: '#fff',
          }}
        >
          <CardMedia
            component="img"
            height="106"
            image="/navigation/tooltip.gif" // Replace with your image source
            alt="Experience your path in 3D"
          />
          <CardContent sx={{ p: 0, pb: '0 !important', mt: '10px', textAlign: rtl ? 'right' : 'left', direction: rtl ? 'rtl' : 'ltr' }}>
            <Typography
              sx={{
                color: '#344054',
                fontSize: '14px',
                fontWeight: rtl ? 500 : 600,
                width: '111px',
                mb: '4px',
                direction: rtl ? 'rtl' : 'ltr',
              }}
            >
              {translation.navExperience || (
                <>
                  Experience your <br /> path in 3D
                </>
              )}
            </Typography>
            <Typography
              sx={{
                color: '#667085',
                fontSize: '12px',
                fontWeight: 400,
                direction: rtl ? 'rtl' : 'ltr',
              }}
            >
              {translation.navClickStart3DNavigation || 'Click start 3D Navigation'}
            </Typography>
          </CardContent>
        </Card>
      }
    >
      {children}
    </Tooltip>
  );
};
